<h3 class="content-block">{{ formatMessage('Dashboard') }}</h3>

<div class="content-block dashboard-content" [class.loading]="loading">
  <div class="dx-card responsive-paddings dashboard-section">
    <div class="dashboard-section-header">
      <i class="dx-icon dx-icon-warning dashboard-section-icon icon-warning"></i>
      <span class="dashboard-section-title">{{ formatMessage('Dashboard alerts') }}</span>
    </div>
    <div class="alert-cards">
      <app-ticker-card
        [titleText]="formatMessage('Unpicked vehicles after pickup deadline')"
        [total]="data.unpickedVehiclesAfterDeadline.toString()"
        [tone]="data.unpickedVehiclesAfterDeadline > 0 ? 'negative' : 'positive'"
        icon="car"
        (click)="onAlertTileClick('unpickedAfterDeadline')"
        style="cursor:pointer"
      ></app-ticker-card>
      <app-ticker-card
        [titleText]="formatMessage('Unpicked vehicles with upcoming pickup deadline')"
        [total]="data.unpickedVehiclesWithUpcomingDeadline.toString()"
        [tone]="data.unpickedVehiclesWithUpcomingDeadline > 0 ? 'warning' : 'positive'"
        icon="clock"
        (click)="onAlertTileClick('unpickedWithUpcomingDeadline')"
        style="cursor:pointer"
      ></app-ticker-card>
      <app-ticker-card
        [titleText]="formatMessage('Unpicked vehicles without pickup deadline')"
        [total]="data.unpickedVehiclesWithoutDeadline.toString()"
        [tone]="data.unpickedVehiclesWithoutDeadline > 0 ? 'warning' : 'positive'"
        icon="deletetable"
        (click)="onAlertTileClick('unpickedWithoutDeadline')"
        style="cursor:pointer"
      ></app-ticker-card>
    </div>
  </div>
  <div class="dx-card responsive-paddings dashboard-section">
    <div class="dashboard-section-header">
      <i class="dx-icon dx-icon-chart dashboard-section-icon icon-info"></i>
      <span class="dashboard-section-title">{{ formatMessage('Orders by status') }}</span>
      <span class="dashboard-section-total">
        {{ formatMessage('All orders') }}: <strong>{{ data.ordersTotal }}</strong>
      </span>
    </div>
    <div class="status-tiles-grid">
      <div *ngFor="let tile of statusTiles"
           class="dashboard-status-tile"
           [ngClass]="tile.cssClass"
           (click)="onStatusTileClick(tile)"
           [title]="getOrderStatus(tile.statusValue)">
        <div class="tile-count">{{ getTileCount(tile.countKey) }}</div>
        <div class="tile-label">{{ getOrderStatus(tile.statusValue) }}</div>
      </div>
    </div>
  </div>
  <div class="dx-card responsive-paddings dashboard-section">
    <div class="dashboard-section-header">
      <i class="dx-icon dx-icon-unselectall dashboard-section-icon icon-info"></i>
      <span class="dashboard-section-title">{{ formatMessage('Recent orders') }}</span>
      <dx-button
        stylingMode="text"
        type="default"
        [text]="formatMessage('Orders')"
        icon="arrowright"
        [routerLink]="['/orders']"
        class="section-link-button">
      </dx-button>
    </div>

    <dx-data-grid
      [dataSource]="data.recentOrders"
      [showBorders]="false"
      [showRowLines]="true"
      [showColumnLines]="false"
      [rowAlternationEnabled]="false"
      [hoverStateEnabled]="true"
      (onRowClick)="onOrderRowClick($event)"
      class="recent-orders-grid">

      <dxo-paging [enabled]="false"></dxo-paging>
      <dxo-scrolling mode="standard"></dxo-scrolling>
      <dxo-sorting mode="none"></dxo-sorting>

      <dxi-column
        dataField="fullNumber"
        [caption]="formatMessage('Number')"
        [width]="140">
      </dxi-column>

      <dxi-column
        [caption]="formatMessage('Vehicle')"
        [calculateCellValue]="getVehicleName"
        [minWidth]="100">
      </dxi-column>

      <dxi-column
        dataField="status"
        [caption]="formatMessage('Status')"
        [minWidth]="220"
        cellTemplate="statusCellTemplate">
      </dxi-column>

      <dxi-column
        dataField="issueDate"
        [caption]="formatMessage('Issue date')"
        dataType="date"
        [format]="dateFormat"
        [width]="120">
      </dxi-column>

      <dxi-column
        dataField="collectionDeadline"
        [caption]="formatMessage('Collection deadline')"
        dataType="date"
        [format]="dateFormat"
        [width]="160">
      </dxi-column>

      <dxi-column
        dataField="supervisorFullName"
        [caption]="formatMessage('Supervisor')"
        [minWidth]="120">
      </dxi-column>

      <div *dxTemplate="let cell of 'statusCellTemplate'">
        <span class="order-status-badge" [ngClass]="getRecentOrderStatusClass(cell.value)">
          {{ getOrderStatus(cell.value) }}
        </span>
      </div>

    </dx-data-grid>
  </div>

</div>
